// JavaScript Document
"use strict";
var Brunckhorst = {
    // All Functions
    lastScrollTop = 0,
    didScroll: true,
    init: function() {

        jQuery(window).resize(function() {
            Brunckhorst.mobileResizeNav();
            Brunckhorst.customCursor();
            Brunckhorst.caseStudiesHover();
            Brunckhorst.loadResize();
            Brunckhorst.heroContent();
            Brunckhorst.heroContentClose();
        });

        jQuery(window).scroll(function() {
            Brunckhorst.stickyheader();
            Brunckhorst.stickyCTA();
        });

		Brunckhorst.loadResize();
        Brunckhorst.stickyheader();
        Brunckhorst.stickyCTA();
        Brunckhorst.fullNavToggle();
        Brunckhorst.mobileResizeNav();
        Brunckhorst.mobileNavToggle();
        Brunckhorst.mobileNavigation();
        Brunckhorst.heroImage();
        Brunckhorst.btnAnimation();
        Brunckhorst.customCursor();
        Brunckhorst.brandSlider();
        Brunckhorst.imageSlider();
        Brunckhorst.caseStudiesHover();
        Brunckhorst.socialLinks();
        Brunckhorst.aosInit();
        Brunckhorst.heroContent();
        Brunckhorst.heroContentClose();
        Brunckhorst.helpCTA();
        Brunckhorst.helpCTAClose();

        // document.addEventListener('touchstart', onTouchStart, {passive: true});
    },

    // Case Studies Hover
    caseStudiesHover: function() {

        $('#caseStudies').each(function () {
            var box = $(this),
                items = $(this).find('.case-studies-content'),
                triggers = $(this).find('.case-studies-image'),
                itemWidth = $(window).width() / 4;

            var openItem = function (num) {
                items.removeClass('active');
                var item = items.eq(num).addClass('active');
            };

            triggers.on('mouseenter', function () {
                openItem(triggers.index($(this)));
            });

            openItem(0);

            box.find('.case-studies-content').each(function (i) {
                if ($(window).width() > 768) {
                    $(this).css('height', box.find('.case-studies-image').eq(i).outerHeight() + 'px');
                    $(this).find(' > * ').css('width', itemWidth + 'px');
                } else {
                    $(this).css({
                        'height': '',
                        'width': ''
                    });

                    $(this).find(' > * ').css({
                        'height': '',
                        'width': ''
                    });
                }
            });
        });
    },

    // Mobile Overlay Toggle
    mobileResizeNav: function() {
        const headerMain = document.querySelector(".header-main");
        const heroMain = document.querySelector(".hero-main");
        const mobileOverlay = document.querySelector(".mobile-overlay");

        if(heroMain == null) {
            document.body.classList.add("no-hero");
        }

        if($(window).width() <= 1024) {
            headerMain.classList.add("mobile-nav-main");
            document.body.classList.add("mobile-enabled");
            if(typeof(heroMain) != 'undefined' && heroMain != null) {
                heroMain.classList.add("mobile-hero-main");
            }
        } else {
            headerMain.classList.remove("mobile-nav-main");
            document.body.classList.remove("mobile-enabled");
            if(typeof(heroMain) != 'undefined' && heroMain != null) {
                heroMain.classList.remove("mobile-hero-main");
            }
            if(mobileOverlay.classList.contains("open")) {
                mobileOverlay.classList.remove("open");
            }
        }
    },

    // Mobile Navigation
    mobileNavigation: function() {
        $(".mobile-nav-list a").click(function() {
            var link = $(this);
            var closest_ul = link.closest("ul");
            var parallel_active_links = closest_ul.find(".active")
            var closest_li = link.closest("li");
            var link_status = closest_li.hasClass("active");
            var count = 0;

            closest_ul.find("ul").slideUp(function() {
                    if (++count == closest_ul.find("ul").length)
                            parallel_active_links.removeClass("active");
            });

            if (!link_status) {
                    closest_li.children("ul").slideDown();
                    closest_li.addClass("active");
            }
        })
    },

    //Banner content on click of word
    heroContent: function() {
        $(".hero-text-main > ul > li").click(function() {
           var thisAttribute= $(this).attr('data-target');
           var window_w = jQuery(window).width();
        //condition for the device width greater then and equal to 768
        $('body').css('overflow','hidden');
           $( ".hero-wrapper" ).each(function() {
            var thisHeroAttribute= $(this).attr('data-attr');
            if (thisHeroAttribute == thisAttribute){
                $(this).addClass('active');
            }else{
                $(this).removeClass('active');
            }
          });

            //$(this).parents(".hero-main").find(".hero-wrapper").addClass('active');
            $(this).parents(".hero-main").find(".hero-bg-outer").addClass('clicked');
            $(this).parents(".hero-main").find(".hero-bg-outer").removeClass('visible');
        });
    },
    heroContentClose: function() {
        $(".hero-bg-content .icon-close").click(function() {
            var window_w = jQuery(window).width();
                $('body').css('overflow','auto');
            $('body').css('overflow','auto');
            $(".hero-wrapper").removeClass('active');
            $(".hero-bg-outer").removeClass('clicked');
        });
    },

    // Banner Image
    heroImage: function() {
        const heroText = document.querySelectorAll(".hero-text");
        const heroImage = document.querySelectorAll(".hero-bg-inner");
        const heroBg = document.querySelector(".hero-bg-outer");
        const heroList = document.querySelector(".hero-text-main > ul");
        const heroListOuter = document.querySelectorAll(".hero-text-main > ul > li");
        let count = 50;

        heroListOuter.forEach(el => {
            el.setAttribute("data-aos", "fade-up");
            el.setAttribute("data-aos-delay", count);
            el.setAttribute("data-aos-offset", 50);
            el.setAttribute("data-aos-easing", "ease-in-out-cubic");
            el.setAttribute("data-aos-once", "true");
            count = count + 50;

            el.addEventListener("mouseenter", (e) => {
                el.classList.add("active");
                heroList.classList.add("hovered");
            })

            el.addEventListener("mouseleave", (e) => {
                el.classList.remove("active");
                heroList.classList.remove("hovered");
            })
        })

        heroText.forEach(el => {
            el.addEventListener("mouseenter", (e) => {
                const id = e.target.id;
                heroBg.classList.add("visible");

                heroImage.forEach((imageEl) => {
                    if(imageEl.getAttribute('data-image') == id) {
                        imageEl.classList.add("image-visible");
                    } else {
                        imageEl.classList.remove("image-visible");
                    }
                })
            })

            el.addEventListener("mouseleave", (e) => {
                heroBg.classList.remove("visible");
                heroImage.forEach((imageEl) => {
                    if(imageEl.classList.contains("image-visible")) {
                        imageEl.classList.remove("image-visible");
                    }
                })
            })
        })
    },

    //Help CTA On click action
    helpCTA: function() {
        $(".help-cta").click(function() {
            $(".help-cta-wrapper").fadeIn();
            $('body').css('overflow','hidden');
            $.getScript("//embed.typeform.com/next/embed.js");
        });
        $(".help-cta-inline").click(function() {
            $(".help-cta-wrapper").fadeIn();
            $('body').css('overflow','hidden');
            $.getScript("//embed.typeform.com/next/embed.js");
        });
    },

    helpCTAClose: function() {
        $(".help-cta-wrapper .icon-close").click(function() {
            $(".help-cta-wrapper").fadeOut();
            $('body').css('overflow','auto');
        });
    },

    // Button Animation
    btnAnimation: function() {
        const button = document.querySelectorAll(".btn-hover");

        button.forEach(el => {
            el.addEventListener("mousemove", (e) => {
                const { x, y } = el.getBoundingClientRect();
                el.style.setProperty("--x", e.clientX - x);
                el.style.setProperty("--y", e.clientY - y);
            });
        })

    },

    // Sticky Header
    stickyheader: function() {

        if ($(window).scrollTop() >= 5) {
            $('.header-main').addClass('header-showed');
            $('.header-main').addClass('header-sticky');
        } else {
            $('.header-main').removeClass('header-showed');
            $('.header-main').removeClass('header-sticky');
        }

    },


    // Animation Timing
    animationTiming: function(selector, delay) {
        const listItem = document.querySelectorAll(selector);
        let mainDelay = delay;

        listItem.forEach(el => {
            el.style.animationDelay = `${mainDelay}s`;
            el.style.transitionDelay = `${mainDelay}s`;
            mainDelay = mainDelay + 0.05;
        })
    },

    // Full Nav Toggle
    fullNavToggle: function() {
        const toggleBtn = document.querySelector("#full-nav-toggle");
        const toggleBtnClose = document.querySelector("#full-nav-toggle-close");
        const fullNavPanel = document.querySelector(".full-page-nav-main");

        this.animationTiming(".full-nav > ul > li", 0.1);
        this.animationTiming(".full-page-nav-main .full-bottom-nav > ul > li", 0.1);

        toggleBtn.addEventListener("click", (e) => {
            if(!fullNavPanel.classList.contains("visible") && !document.body.classList.contains("overflow-hidden")) {
                fullNavPanel.classList.add("visible");
                document.body.classList.add("overflow-hidden");
            }
        })

        toggleBtnClose.addEventListener("click", (e) => {
            if(fullNavPanel.classList.contains("visible") && document.body.classList.contains("overflow-hidden")) {
                fullNavPanel.classList.remove("visible");
                document.body.classList.remove("overflow-hidden");
            }
        })
    },

    // Mobile Nav Toggle
    mobileNavToggle: function() {
        const toggleBtn = document.querySelector("#mobile-nav-open");
        const toggleBtnClose = document.querySelector("#mobile-nav-close");
        const mobileOverlay = document.querySelector(".mobile-overlay");

        this.animationTiming(".mobile-nav-list > ul > li", 0.1);

        toggleBtn.addEventListener("click", (e) => {
            if(!mobileOverlay.classList.contains("open")) {
                mobileOverlay.classList.add("open");
            }
        })

        toggleBtnClose.addEventListener("click", (e) => {
            if(mobileOverlay.classList.contains("open")) {
                mobileOverlay.classList.remove("open");
            }
        })
    },

    loadResize: function () {
        var window_w = jQuery(window).width();
        //condition for the device width greater then and equal to 768
        if (window_w <= 1024) {
            /*script for below desktop menu mouse hover and out*/
            // only checks after 300ms
            setInterval(function() {
                if (Brunckhorst.didScroll) {
                    Brunckhorst.Menu_OnScroll_Event();
                    Brunckhorst.didScroll = false;
                }
            }, 300);
        }
    },

    //Mobile Nav sticky visible when scroll up and hidden when go down
    Menu_OnScroll_Event: function () {

		// Hide Header on on scroll down
			var delta = 25;
			var navbarHeight = jQuery('.header-main').outerHeight();

		jQuery(window).off("scroll").scroll(function(event){
            Brunckhorst.stickyheader();
            Brunckhorst.stickyCTA();
			var currentScrollTop = jQuery(this).scrollTop();

            // lconsole.log(currentScrollTop + "," + Brunckhorst.lastScrollTop);

			// If scroll direction is down and greater than the scroll event threshold
			// We're scrolling down

            // if(Math.abs(Brunckhorst.lastScrollTop - currentScrollTop) > delta){
            if(false){
				if(currentScrollTop > Brunckhorst.lastScrollTop) {
                    console.log('scrolling down...');
					//if we're at the bottom of the page
					if(currentScrollTop > jQuery(document).height() - jQuery(window).height() - 80) {
						// add class to fix header and remove the hide class
						// show the header
						jQuery(".header-main").removeClass("header-nav-hide");
                        jQuery(".header-main").addClass("header-sticky");
                        jQuery(".header-main").addClass("mobile-header-showed");
					}
					else {
						// hide the header scrolling down
						jQuery(".header-main").addClass("header-nav-hide");
                        jQuery(".header-main").removeClass("header-sticky");
                        jQuery(".header-main").removeClass("mobile-header-showed");
					}
				// We're scrolling up
				} else {
                    console.log('scrolling up...');
					// show the header
					jQuery(".header-main").removeClass("header-nav-hide");
                    jQuery(".header-main").addClass("header-sticky");
                    jQuery(".header-main").addClass("mobile-header-showed");
				}
				// Update the last scroll position
				Brunckhorst.lastScrollTop = currentScrollTop;
			}

            // When scroll reaches to top will get original header
            if(currentScrollTop <= 5){
                // jQuery(".header-main").removeClass("header-sticky");
                jQuery(".header-main").removeClass("mobile-header-showed");
            } else {
                jQuery(".header-main").addClass("mobile-header-showed");
            }
		});

	},

    //Sticky Call to Action bgcolor change @footer
    stickyCTA: function() {
        var element_top = $('.help-cta').offset().top;
        var div_top = $('.footer-bottom').offset().top;
        //console.log(element_top + "," + div_top);
        if (element_top > (div_top-50)){
            console.log("inif");
            $('.help-cta').addClass('active');
         }else {
            //console.log("else");
            $('.help-cta').removeClass('active');
        }
    },

    // Custom Cursor
    customCursor: function() {

        const cursorInnerEl = document.querySelector('.circle-cursor--inner');
        const cursorOuterEl = document.querySelector('.circle-cursor--outer');

        if($(window).width() > 1024) {
            let lastY, lastX = 0;
            let magneticFlag = false;

            // move
            window.onmousemove = function (event) {
                if (!magneticFlag) {
                    cursorOuterEl.style.transform = 'translate('+ event.clientX + 'px, ' + event.clientY + 'px' +')';
                }

                cursorInnerEl.style.transform = 'translate('+ event.clientX + 'px, ' + event.clientY + 'px' +')';

                lastY = event.clientY;
                lastX = event.clientX;
                cursorInnerEl.style.visibility = 'visible';
                cursorOuterEl.style.visibility = 'visible';
            }
        } else {
            cursorInnerEl.style.visibility = 'hidden';
            cursorOuterEl.style.visibility = 'hidden';
        }
    },

    // Brand Slider
    brandSlider: function() {
        $('.brand-slider').slick({
            dots: false,
            arrows: false,
            infinite: true,
            speed: 300,
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            centerMode: true,
            variableWidth: true
          });
    },

    // Image Slider
    imageSlider: function() {
        $('.image-slider').slick({
            dots: false,
            arrows: false,
            infinite: true,
            speed: 1500,
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            centerMode: true,
            variableWidth: true
          });
    },

    // Social Links Color Change
    socialLinks: function() {
        var section = $('.dark-section, .light-section');
        var sectionClass;

        if (section.length) {
            var socialLinks = $('.social-icons.desktop');
            var self_window;

            activeSection($(window));

            $(window).on('scroll', function () {
                self_window = $(this);
                activeSection(self_window);
            });

            function activeSection(self_window) {
                var st = self_window.scrollTop() + self_window.height() / 2;
                section.each(function () {

                    var sectionOffset = $(this).offset().top;
                    var currentSection = $(this);

                    if (currentSection.hasClass('hero-main')) {
                        if (!(st > ($(document).height() - self_window.height()))) {
                            socialLinks.removeClass('social-light social-dark');
                            return;
                        }
                    }

                    if (currentSection.hasClass('dark-section')) {
                        sectionClass = 'social-light';
                    } else if (currentSection.hasClass('light-section')) {
                        sectionClass = 'social-dark';
                    }

                    if (sectionOffset + currentSection.outerHeight() > st && st > sectionOffset) {
                        socialLinks.addClass(sectionClass);
                        return false;
                    } else {
                        socialLinks.removeClass(sectionClass);
                    }
                });
            }
        }
    },

    // AOS
    aosInit: function() {
        AOS.init();
    },

};

// when the page is ready, initialize everything
jQuery(document).ready(function() {

    Brunckhorst.init();

});
